import _ from 'lodash';
import * as numeral from 'numeral';

require('numeral/locales.js');
numeral.locale('pt-br');

export const numeralMixin = {
  methods: {
    numeral(value) {
      return numeral(value);
    },

    formatNumber(value, format = '0,0') {
      if (value === undefined) {
        return '';
      }

      let number = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      if (format === '0a' && number > 9999) {
        const lang = numeral.locale();
        numeral.locale('en');
        number = numeral(number).format('0a');
        numeral.locale(lang);
      }
      return numeral(number).format(format);
    },

    toNumber(value) {
      return numeral(value).value();
    },

    getMax(values, property, variation = 1) {
      if (!values) {
        return 0;
      }
      if (!property) {
        return _.max(values);
      }

      const value = Math.ceil((_.maxBy(values, v => v && v[property]) || {})[property] * variation);
      return isNaN(value) ? 0 : value;
    },

    getMaxFromProperties(values, properties, variation = 1, ceil = true) {
      if (!_.size(values)) {
        return 0;
      }

      const maxValues = _.map(properties, (property) => (_.maxBy(values, v => v && v[property]) || {})[property]);
      const value = ceil ? Math.ceil(_.max(maxValues) * variation) : _.max(maxValues) * variation;
      return isNaN(value) ? 0 : value;
    },

    getRangeScaleFromProperties(values, properties, scale = 0) {
      if (!_.size(values)) {
        return 0;
      }

      const maxValues = _.map(properties, (property) => (_.maxBy(values, v => v && v[property]) || {})[property]);
      const maxValue = _.max(maxValues);

      const minValues = _.map(properties, (property) => (_.minBy(values, v => v && v[property]) || {})[property]);
      const minValue = _.min(minValues);

      if (isNaN(maxValue) || isNaN(minValue)) {
        return 0;
      }

      const range = (maxValue - minValue) * scale;

      if (scale < 0) {
        return minValue + range;
      } else {
        return maxValue + range;
      }
    },

    getMin(values, property, variation = 1) {
      if (!values) {
        return 0;
      }
      if (!property) {
        return _.min(values);
      }

      const value = Math.floor((_.minBy(values, v => v && v[property]) || {})[property] * variation);
      return isNaN(value) ? 0 : value;
    },

    getMinFromProperties(values, properties, variation = 1, floor = true) {
      if (!_.size(values)) {
        return 0;
      }

      const minValues = _.map(properties, (property) => (_.minBy(values, v => v && v[property]) || {})[property]);
      const minValue = (floor ? Math.floor(_.min(minValues)) : _.min(minValues));
      const value = minValue - Math.abs(minValue * variation);

      return isNaN(value) ? 0 : value;
    },

    hasValuesFromProperties(values, properties) {
      if (!_.size(values)) {
        return false;
      }

      return _.some(properties, (property) => _.some(values, v => v[property] !== undefined));
    }
  }
};
